import React from "react"

import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Link from "../components/Link"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types"

const Bold = ({ children }) => <b>{children}</b>
const Italic = ({ children }) => <i>{children}</i>
const Text = ({ children }) => <p>{children}</p>

export const options = {
  renderMark: {
    [MARKS.BOLD]: text => <Bold>{text}</Bold>,
    [MARKS.ITALIC]: text => <Italic>{text}</Italic>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
    [INLINES.HYPERLINK]: (node, children) => {
      let uri = node.data.uri

      // Assuming internal links do not include the domain name and start with "/"
      const isInternal = uri.startsWith("/") || uri.includes("emento.de")
      const fileLinkRegex =
        /\.(jpeg|jpg|gif|png|pdf|doc|docx|xls|xlsx|ppt|pptx|zip|rar|tar|gz|txt|mp3|mp4)$/i
      const isFileLink =
        fileLinkRegex.test(uri) ||
        uri.includes("mailto:") ||
        uri.includes("tel:")

      // Ensure internal links have exactly one trailing slash and are not file links
      if (isInternal && !isFileLink && !uri.endsWith("/")) {
        uri = `${uri}/` // Append trailing slash
      }
      if (isInternal) {
        return <Link to={uri}>{children}</Link>
      }
      if (uri.includes("youtube.com")) {
        const youtubeuri = node.data.uri.replace("watch?v=", "embed/")
        return (
          <div className="blog-video-container">
            <iframe
              width="560"
              height="315"
              src={youtubeuri}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )
      }
      if (uri.includes("vimeo.com")) {
        // Extract the Vimeo ID from either format
        const vimeoId = uri.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1]
        return (
          <div className="blog-video-container">
            <iframe
              src={`https://player.vimeo.com/video/${vimeoId}`}
              width="560"
              height="315"
              frameBorder="0"
              title="Vimeo video player"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )
      }
      if (uri.includes("podigee.io")) {
        return (
          <iframe
            src={node.data.uri}
            height="150"
            width="960"
            title="video-container-vimeo"
            scrolling="no"
            frameBorder="0"
            sandbox="allow-scripts allow-same-origin allow-top-navigation"
            layout="fixed-height"
          ></iframe>
        )
      }
      // make sure external hyperlinks always open in new window:
      return (
        <Link to={uri} target="_blank" rel="noreferrer">
          {children}
        </Link>
      )
    },
    [BLOCKS.HEADING_2]: (node, children) => {
      return <h2>{children}</h2>
    },
    [INLINES.EMBEDDED_ENTRY]: (node, children) => {
      //console.log("ENTRY")
      console.log(node)
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      //console.log("BLOCK ENTRY")
      //console.log(node)
      return (
        <a
          href={node.data.target.linkedAsset.file.url}
          target="_blank"
          rel="noreferrer"
        >
          <div className="blog-download-asset">
            <div className="blog-download-asset-header">DOWNLOAD</div>
            <div className="blog-download-asset-image">
              <div className="blog-download-asset-image-wrapper">
                <GatsbyImage
                  image={getImage(node.data.target.thumbnail)}
                  alt={node.data.target.description}
                />
              </div>
            </div>
            <div className="blog-download-asset-description">
              <h5>{node.data.target.description}</h5>
            </div>
          </div>
        </a>
      )
    },
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
      //console.log("ASSET:")
      //console.log(node)
      const assetType = node.data.target.file.contentType
      switch (assetType) {
        case "video/mp4":
          return (
            <video width="100%" height="100%" playsInline loop autoPlay>
              <source src={node.data.target.file.url} type="video/mp4" />
              <track
                src={node.data.target.file.description}
                kind="captions"
                srcLang="en"
                label="captions"
              ></track>
            </video>
          )
        default:
          return (
            <GatsbyImage
              image={getImage(node.data.target)}
              alt={node.data.target.title}
            />
          )
      }
    },
  },
}

export const renderLinkedIn = linkedIn => {
  return (
    <a
      href={`https://www.linkedin.com/in/${linkedIn}`}
      target="_blank"
      rel="noreferrer"
    >
      <img
        className="social_icon"
        src="/images/social_icons/Linkedin_1.png"
        alt="LinkedIn profile"
      />
    </a>
  )
}

export const renderTwitter = twitter => {
  return (
    <a
      href={`https://www.twitter.com/${twitter}`}
      target="_blank"
      rel="noreferrer"
    >
      <img
        className="social_icon"
        src="/images/social_icons/Twitter_1.png"
        alt="Twitter profile"
      />
    </a>
  )
}
